import { useEffect, useState } from "react";
import {useTranslation} from "react-i18next";

import "./assets/css/CookiePopup.css";
import {getdirection} from "./helper/function";
import {Lang} from "./helper/setting";

const COOKIE_NAME = "cookie_consent";

function getCookie(name: string): string | null {

    const value = document.cookie

        .split("; ")

        .find((row) => row.startsWith(name + "="));

    return value ? value.split("=")[1] : null;

}

function setCookie(name: string, value: string, days: number) {

    const date = new Date();

    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);

    document.cookie = `${name}=${value}; expires=${date.toUTCString()}; path=/; SameSite=Lax`;

}

export default function CookiePopup() {

    const t = useTranslation()

    const [show, setShow] = useState(false);

    useEffect(() => {

        const consent = getCookie(COOKIE_NAME);

        if (!consent) {

            setShow(true);

        }

    }, []);

    const acceptCookies = () => {

        setCookie(COOKIE_NAME, "accepted", 180);

        setShow(false);

    };

    const rejectCookies = () => {

        setCookie(COOKIE_NAME, "rejected", 180);

        setShow(false);

    };

    if (!show) return null;

    return (

        <div className="cookie-popup" dir={sessionStorage.getItem("dir") ?? ''}>

            <div className="cookie-content">


                <p>

                    {t.t("cookie.consent")}{" "}

                    <a href={`${Lang[Number(localStorage.getItem("langId")) ?? 0].label}/page/86/${t.t("privacy").replaceAll(" ", "_")}`} >

                        {t.t("cookie.policy")}

                    </a>

                </p>
                <div className="cookie-buttons">



                    <button className="btn primary" style={{fontSize:(Lang[Number(localStorage.getItem("langId"))].label  == 'ar' ? 12 : 16)}} onClick={acceptCookies}>

                        {t.t("cookie.accept")}

                    </button>
                    <button className="btn outline" style={{fontSize:(Lang[Number(localStorage.getItem("langId"))].label  == 'ar' ? 12 : 16)}} onClick={rejectCookies}>

                        {t.t("cookie.reject")}

                    </button>
                </div>

            </div>

        </div>

    );

}
